/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BrowserRegistrationSettingsSaveRequest} from '../models/BrowserRegistrationSettingsSaveRequest';
import type {Error} from '../models/Error';

export interface SaveBrowserRegistrationSettings$Request {
    userId: number;
    browserRegistrationSettingsSaveRequest: BrowserRegistrationSettingsSaveRequest;
}

export interface SaveBrowserRegistrationSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveBrowserRegistrationSettingsRequest = createAction<PayloadData<void, SaveBrowserRegistrationSettings$Request>>('SAVE_BROWSER_REGISTRATION_SETTINGS__SAVE_BROWSER_REGISTRATION_SETTINGS__REQUEST');
export const saveBrowserRegistrationSettingsSuccess = createAction<PayloadData<void, SaveBrowserRegistrationSettings$Request>>('SAVE_BROWSER_REGISTRATION_SETTINGS__SAVE_BROWSER_REGISTRATION_SETTINGS__SUCCESS');
export const saveBrowserRegistrationSettingsFailure = createAction<PayloadData<Error, SaveBrowserRegistrationSettings$Request, true>>('SAVE_BROWSER_REGISTRATION_SETTINGS__SAVE_BROWSER_REGISTRATION_SETTINGS__FAILURE');

export const saveBrowserRegistrationSettingsActions = [
    saveBrowserRegistrationSettingsRequest,
    saveBrowserRegistrationSettingsSuccess,
    saveBrowserRegistrationSettingsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {BrowserRegistrationSettingsSaveRequest} meta.browserRegistrationSettingsSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveBrowserRegistrationSettings = (meta: SaveBrowserRegistrationSettings$Request, config?: SaveBrowserRegistrationSettings$Config) => {
    return {
        CALL_API: {
            types: saveBrowserRegistrationSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/browser-registration/settings`,
            TRANSPORT_REQUEST_BODY: meta.browserRegistrationSettingsSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

